import { getWeeksOfPeriode } from 'containers/Programmations/ProgV2/utils/getWeeksOfPeriode';
import { Zone } from '@teetsh/app/src/types/zone';
import { getPeriodeColor } from '../New/getColors';
import { Periode } from 'types/programmations';
import { v4 as uuid } from 'uuid';

export function getSchoolyearWeeks({
  zone,
  weekLabelFt,
  sundayStart,
}: {
  zone?: Zone;
  weekLabelFt: (n: number) => string;
  sundayStart: boolean;
}): Periode[] {
  return (zone?.periodes || [])
    .filter(p => p.from && p.to)
    .reduce((acc, p, periodeIdx) => {
      const maxWeekPosition = acc.reduce(
        (max, curr) => Math.max(max, curr.position || 0),
        0,
      );
      const newWeeks = getWeeksOfPeriode(
        p.from!,
        p.to!,
        n => weekLabelFt(n),
        sundayStart,
      ).map((v, weekIdx) => ({
        id: uuid(),
        startDate: v.from,
        endDate: v.to,
        name: v.label,
        color: p.color || getPeriodeColor(periodeIdx),
        position: maxWeekPosition + weekIdx + 1,
      }));

      return [...acc, ...newWeeks];
    }, [] as Periode[]);
}
